import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  buildPromotionChips,
  buildPromotionExpiryUrgency,
  buildPromotionHeadline,
  PromotionChipView,
  PromotionDetailPromotion,
  PromotionExpiryUrgencyView,
  PromotionHeadlineView,
} from 'src/app/shared/promotion-detail-modal/promotion-display.util';
import { LanguageService } from 'src/app/services/language.service';
import { PromotionCardPromotionLike } from './promotion-card.model';

@Component({
  selector: 'app-promotion-card',
  templateUrl: './promotion-card.component.html',
  styleUrls: ['./promotion-card.component.scss'],
})
export class PromotionCardComponent {
  @Input({ required: true }) promotion!: PromotionCardPromotionLike;
  @Output() reserve = new EventEmitter<PromotionCardPromotionLike>();
  @Output() detail = new EventEmitter<PromotionCardPromotionLike>();

  constructor(
    private readonly translate: TranslateService,
    private readonly languageService: LanguageService,
  ) {}

  get bannerSrc(): string {
    return this.promotion?.banner ?? './assets/img/image-not-found.png';
  }

  get bannerAlt(): string {
    return this.promotion?.title ?? '';
  }

  get branchLabel(): string {
    return this.chips.branchLabel || this.promotion?.branch?.branchName || '';
  }

  private get headlineView(): PromotionHeadlineView {
    return buildPromotionHeadline(
      this.promotion as PromotionDetailPromotion,
      (key, params) => this.translate.instant(key, params),
      this.languageService.getLocaleTag(),
    );
  }

  private get chips(): PromotionChipView {
    return buildPromotionChips(
      this.promotion as PromotionDetailPromotion,
      (key, params) => this.translate.instant(key, params),
      this.languageService.getLocaleTag(),
    );
  }

  private get expiryUrgency(): PromotionExpiryUrgencyView {
    return buildPromotionExpiryUrgency(
      this.promotion,
      (key, params) => this.translate.instant(key, params),
    );
  }

  get headlineLead(): string {
    return this.headlineView.headlineLead;
  }

  get oldPriceLabel(): string {
    return this.headlineView.oldPriceLabel;
  }

  get newPriceLabel(): string {
    return this.headlineView.newPriceLabel;
  }

  get currencyLabel(): string {
    return this.headlineView.currencyLabel;
  }

  get operationLabel(): string {
    return this.headlineView.operationLabel;
  }

  get hasStructuredHeadline(): boolean {
    return this.headlineView.hasStructuredHeadline;
  }

  get fallbackHeadline(): string {
    return this.headlineView.fallbackTitle;
  }

  get availabilityLabel(): string {
    return this.chips.availabilityLabel;
  }

  get discountLabel(): string {
    return this.chips.discountLabel;
  }

  get validityLabel(): string {
    return this.chips.validityLabel;
  }

  get showExpiryBadge(): boolean {
    return this.expiryUrgency.showExpiryBadge;
  }

  get expiryBadgeLabel(): string {
    return this.expiryUrgency.expiryBadgeLabel;
  }

  get isValidityUrgent(): boolean {
    return this.expiryUrgency.isValidityUrgent;
  }

  onReserve(): void {
    this.reserve.emit(this.promotion);
  }

  onDetail(): void {
    this.detail.emit(this.promotion);
  }
}
